module.exports = __webpack_public_path__ + "img/newspapers_button_next_up.ee33c42a.png";